import { Capacitor } from '@capacitor/core';
import { NotificationsApi } from '@up2stay/up2promo-api-client';

import {
  getPushPermissionStatus,
  requestPushPermissionAndRegister,
} from '@/core/lib/push-notifications';
import { isCapacitorNative } from '@/core/utils/capacitor.utils';

export async function applyPushGrantDefaults(
  workspaceId: string,
): Promise<string[]> {
  const response = await NotificationsApi.applyPushGrantDefaults({
    body: { workspaceId },
  });
  return response.data?.updatedTypeIds ?? [];
}

export async function completePushGrantFlow(
  workspaceId: string,
): Promise<boolean> {
  const result = await requestPushPermissionAndRegister();
  if (!result.granted) {
    return false;
  }

  await applyPushGrantDefaults(workspaceId);
  return true;
}

export async function syncPushGrantIfPermitted(
  workspaceId: string,
): Promise<void> {
  if (!isCapacitorNative()) return;

  const status = await getPushPermissionStatus();
  if (status !== 'granted') return;

  await requestPushPermissionAndRegister();
  await applyPushGrantDefaults(workspaceId);
}

export async function openSystemNotificationSettings(): Promise<void> {
  if (!isCapacitorNative()) return;

  const platform = Capacitor.getPlatform();
  if (platform === 'ios') {
    window.location.href = 'app-settings:';
    return;
  }

  if (platform === 'android') {
    window.location.href =
      'intent:#Intent;action=android.settings.APPLICATION_DETAILS_SETTINGS;data=package:com.up2promo.app;end';
  }
}
